import { Link, Text } from '@ecoinvent/ui';

import { TourStep } from '../Tour/types';

// Reuse existing env variables from LicensedTour
export { TOUR_DATASET_ID, TOUR_SYSTEM_MODEL, TOUR_VERSION } from '../LicensedTour/constants';

export const UNLICENSED_TOUR_SEARCH_QUERY = 'kiwi%20production';

export const UNLICENSED_TOUR_STEPS: TourStep[] = [
  {
    id: 'welcome',
    type: 'card',
    title: 'Welcome to ecoQuery',
    content: (
      <Text>
        Explore 26,000+ life cycle inventory datasets. Search activities, view environmental impacts, and trace connections
        across supply chains.
      </Text>
    ),
    buttonText: 'Start Exploring',
    path: 'home',
  },
  {
    id: 'find-search',
    type: 'coachmark',
    targetId: 'search-bar',
    placement: 'top',
    title: 'Find What You Need',
    content: (
      <Text>
        Type any{' '}
        <Link href="https://support.ecoinvent.org/activities-products#Activities" isExternal>
          activity
        </Link>{' '}
        or{' '}
        <Link href="https://support.ecoinvent.org/activities-products#Products" isExternal>
          product
        </Link>{' '}
        into the search bar—electricity, steel, transport, or anything else—and the platform instantly finds matching datasets.
        Each dataset in ecoQuery represents a unit process of a human activity and its exchanges with the environment and other
        activities.
      </Text>
    ),
    path: 'home',
  },
  {
    id: 'refine-search',
    type: 'coachmark',
    targetId: 'search-filters',
    placement: 'bottom',
    title: 'Refine Your Search',
    content: (
      <Text>
        Use filters to narrow down your results by different criteria. You can filter by{' '}
        <Link href="https://support.ecoinvent.org/geographies" isExternal>
          Geography
        </Link>
        ,{' '}
        <Link href="https://support.ecoinvent.org/sector-overview" isExternal>
          Sector
        </Link>
        , or{' '}
        <Link href="https://support.ecoinvent.org/activities-products#Types_Activities" isExternal>
          Activity type
        </Link>{' '}
        to focus on the most relevant datasets for your analysis.
      </Text>
    ),
    path: 'search',
  },
  {
    id: 'navigate-results',
    type: 'coachmark',
    targetId: 'search-results-group',
    placement: 'top',
    title: 'Navigate Your Results',
    content: (
      <Text>
        Search results are grouped by activity type . Each group can contain one or multiple datasets representing different
        geographies for the same activity. This structure helps you quickly find the exact dataset you need.
      </Text>
    ),
    path: 'search',
  },
  {
    id: 'dataset-details',
    type: 'coachmark',
    targetId: 'dataset-tabs',
    placement: 'bottom',
    title: 'Understand Dataset Details',
    content: (
      <Text>
        The Documentation tab displays general information and key details about the dataset —{' '}
        <Link href="https://support.ecoinvent.org/introduction-to-the-database" isExternal>
          modeling assumptions
        </Link>
        ,{' '}
        <Link href="https://support.ecoinvent.org/system-models" isExternal>
          system boundaries
        </Link>
        , and technical specifications. The{' '}
        <Link href="https://support.ecoinvent.org/glossary-e#E-Exchange" isExternal>
          Exchanges
        </Link>{' '}
        tab contains{' '}
        <Link href="https://support.ecoinvent.org/impact-assessment" isExternal>
          Impact Assessment
        </Link>{' '}
        and{' '}
        <Link href="https://support.ecoinvent.org/upr-lci-lcia#LCI" isExternal>
          LCI{' '}
        </Link>{' '}
        Results tabs contain environmental impact data.
      </Text>
    ),
    path: 'documentation',
  },
  {
    id: 'completion',
    type: 'card',
    title: 'Start Exploring ecoQuery',
    content: (
      <Text>
        You're all set to start exploring! As you browse, look for the '?' icons to learn more about specific topics. To unlock
        access to more features,{' '}
        <Link href="https://ecoinvent.org/licenses/" isExternal>
          explore our licenses
        </Link>
        .
      </Text>
    ),
    buttonText: 'Finish Tour',
    path: 'documentation',
  },
];
